import React, { useEffect } from "react"
import { NavLink, ScrollRestoration } from 'react-router-dom'
import './BackgroundAnimation.scss'

const Home = () => {

    useEffect(() => {
        const interBubble = document.querySelector('.interactive')
        let curX = 0;
        let curY = 0;
        let tgX = 0;
        let tgY = 0;

        function move() {
        curX += (tgX - curX) / 20;
        curY += (tgY - curY) / 20;
        interBubble.style.transform = `translate(${Math.round(curX)}px, ${Math.round(curY)}px)`;
        requestAnimationFrame(move);
        }

        const handleMouseMove = (event) => {
        tgX = event.clientX;
        tgY = event.clientY;
        };


        window.addEventListener('mousemove', handleMouseMove);

        move();

        return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        };
    }, [])

    // useEffect(() => {
    //     const sections = document.querySelectorAll(".scroll-section");
    //     let isScrolling = false;

    //     const handleScroll = (event) => {
    //         if (isScrolling) return;
    //         if (Math.abs(event.deltaY) < 10) return;
    //         isScrolling = true;
        
    //         setTimeout(() => { isScrolling = false; }, 1000);
        
    //         const direction = event.deltaY > 0 ? 1 : -1;
    //         let currentSectionIndex = Array.from(sections).findIndex(sec => 
    //             window.scrollY < sec.offsetTop + sec.offsetHeight / 2
    //         );
        
    //         if (currentSectionIndex === -1) return;
    //         let targetIndex = Math.max(0, Math.min(sections.length - 1, currentSectionIndex + direction));
    //         sections[targetIndex].scrollIntoView({ behavior: "smooth" });
    //     };

    //     window.addEventListener("wheel", handleScroll);
    //     return () => {
    //         window.removeEventListener("wheel", handleScroll);
    //     }
    // }, [])

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" })
        }
    }
    
    return (
        <div className="background-animation">
        
        <div className="content-wrapper">
            <div className="scroll-section">
                <div className="text-container-1">StayWithMe</div>
                <div className="text-container-2">Create AI versions of real people.</div>
                <div className="button-container">
                    <div>
                        <NavLink to="/upload-chats" >
                            <button type="button"  className="create-button" >
                                Create
                            </button>
                        </NavLink>
                    </div>
                    <div>
                        <button className="learn-button" onClick={() => scrollToSection('how-it-works-section')}>
                            Learn More
                        </button>
                    </div>
                </div>
                <button className="scroll-button" onClick={() => scrollToSection('how-it-works-section')}></button>
            </div>

            <div className="scroll-section" id="how-it-works-section">
                <div className="section-header">
                    <div className="text-container-1">How it works?</div>
                </div>

                <div className="section-content">

                <div className="section-content">
                    <div className="steps-container">
                        <div className="step">
                            <div className="step-icon">
                                🧑‍💻
                            </div>
                            <div className="step-text">
                                <h3>Step 1: Digital Interview</h3>
                                <div>We conduct a personalized interview to gather important details about your loved one’s life, values, and experiences.</div>
                            </div>
                        </div>

                        <div className="step">
                            <div className="step-icon">
                                🔗
                            </div>
                            <div className="step-text">
                                <h3>Step 2: Social Media Connection</h3>
                                <div>We integrate with their social media to collect their memories, messages, and expressions, ensuring their digital self is accurate.</div>
                            </div>
                        </div>

                        <div className="step">
                            <div className="step-icon">
                                🗣️
                            </div>
                            <div className="step-text">
                                <h3>Step 3: Stay Connected Forever</h3>
                                <div>Once created, you and your family can interact with their digital self, hearing responses in their voice and sharing new memories over time.</div>
                            </div>
                        </div>
                    </div>
                </div>


                </div>

                <button className="scroll-button" onClick={() => scrollToSection('contact-section')}></button>
            </div>

            <div className="scroll-section" id="contact-section">

                <div className="section-header">
                    <div className="text-container-1">Contact us</div>
                </div>

                <div className="section-content">
                    <a href="mailto:support@staywithme.io">support@staywithme.io</a>
                </div>


            </div>
        </div>


        <div className="gradient-bg">
            <svg xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <filter id="goo">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                    <feColorMatrix
                        in="blur"
                        mode="matrix"
                        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8"
                        result="goo"
                    />
                    <feBlend in="SourceGraphic" in2="goo" />
                    </filter>
                </defs>
            </svg>
            <div className="gradients-container">
                <div className="g1"></div>
                <div className="g2"></div>
                <div className="g3"></div>
                <div className="g4"></div>
                <div className="g5"></div>
                <div className="interactive"></div>
            </div>
        </div>

        </div>
    );
}


export default Home;